import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  Signal
} from '@angular/core';
import { VerticalTabsComponent } from '../../../../shared/components/tabs/vertical-tabs/vertical-tabs.component';
import { RouterOutlet } from '@angular/router';
import { MY_ACCOUNT_PERSONAL_TABS } from '../../constants/my-account-personal-tabs.constant';
import { MY_ACCOUNT_GENERAL_TABS } from '../../constants/my-account-general-tabs.constant';
import { MyAccountUserComponent } from '../../components/my-account-user/my-account-user.component';
import { Store, select } from '@ngxs/store';
import { UserProfileState } from '../../../../shared/state/user-profile/user-profile.state';
import { LoadUserProfileAction } from '../../../../shared/state/user-profile/user-profile.actions';

@Component({
  selector: 'app-my-account-container',
  templateUrl: './my-account-container.component.html',
  styleUrl: './my-account-container.component.scss',
  imports: [VerticalTabsComponent, RouterOutlet, MyAccountUserComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyAccountContainerComponent implements OnInit {
  protected readonly MY_ACCOUNT_PERSONAL_TABS = MY_ACCOUNT_PERSONAL_TABS;
  protected readonly MY_ACCOUNT_GENERAL_TABS = MY_ACCOUNT_GENERAL_TABS;

  private readonly store = inject(Store);

  userName: Signal<string> = select(UserProfileState.displayName);
  userAvatar: Signal<string> = select(UserProfileState.avatarUrl);

  ngOnInit(): void {
    this.store.dispatch(new LoadUserProfileAction());
  }
}
